/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-08 17:13:02
 */ 
import axios from '../axios'

/* 
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/admin/service/sys_group_saveAndUpdate',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/dept/delete',
        method: 'post',
        data
    })
}
// 查询机构树以前的
// export const findDeptTree = () => {
//     return axios({
//         url: '/dept/findTree',
//         method: 'get'
//     })
// }
export const findDeptTree = (data) => {
    return axios({
        // url: '/main/mechanism/array',//强哥
        url:'/admin/service/sys_group_array',
        method: 'post',
        data
    })
}


///查询小区的列表admin/service/sys_community_array

export const getCommunityList = (data) => {
    return axios({
        
        url:'/admin/service/sys_community_array',
        method: 'post',
        data
    })
}
//网格
export const getGridList = (data) => {
    return axios({
        url:'/admin/service/sys_grid_array',
        method: 'post',
        data
    })
}

//网格新增
export const getGridadd = (data) => {
    return axios({
        url:'/admin/service/sys_grid_add',
        method: 'post',
        data
    })
}
//网格人员新增
export const getPersondadd = (data) => {
    return axios({
        url:'/admin/service/sys_gridPerson_add',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dept.js